import { TradingOffer } from 'types/TradingOffer';
import { TradingOfferOperation } from 'types/TradingOfferOperation';
import {
  Board,
  Committee,
  Communication,
  Council,
  Document,
  Guest,
  HoldingClass,
  Note,
  Operation,
  Partner,
  PartnerRepresentant,
  Realty,
  Share,
  SharesTitle,
  Society,
  StockPlan,
  TenderOffer,
  User,
} from 'types';
import { EnvelopeWithStatus } from 'types/Envelope';
import { AdminPermissions } from 'types/User';

export type State = {
  user: User;
  partnerBook: Record<string, any>;
  menu: Record<string, any>;
  sideNav: boolean;
  alerts: any[];
  documents: Document[];
  envelopes: EnvelopeWithStatus[];
  modal: any;
  society: {
    actualSociety: Society;
    role: Record<string, any>;
    permissions: AdminPermissions;
  };
  employees: Record<string, any>[];
  employeesPlans: Record<string, any>[];
  plans: StockPlan[];
  drafts: Record<string, any>[];
  holdingClasses: HoldingClass[];
  tenderOffers: TenderOffer[];
  tenderOffersShares: Record<string, any>[];
  boards: Board[];
  communications: Communication[];
  preview: Record<string, any>;
  notification: Record<string, any>;
  fullWidth: boolean;
  partnerCategories: Record<string, any>[];
  partnerRepresentants: PartnerRepresentant[];
  globalNotifications: Record<string, any>[];
  guests: Guest[];
  committees: Committee[];
  councils: Council[];
  realties: Realty[];
  sharesTitles: SharesTitle[];
  partners: Partner[];
  operations: Operation[];
  notes: Note[];
  shares: Share[];
  tradingOffers: TradingOffer[];
  tradingOfferOperations: TradingOfferOperation[];
};

const initialState = {
  user: null,
  partnerBook: null,
  menu: { type: 'MAIN' },
  sideNav: false,
  alerts: [],
  documents: [],
  envelopes: [],
  modal: null,
  society: null,
  employees: [],
  employeesPlans: [],
  plans: [],
  drafts: [],
  holdingClasses: [],
  tenderOffers: [],
  tenderOffersShares: [],
  boards: [],
  communications: [],
  preview: null,
  notification: null,
  fullWidth: false,
  partnerCategories: [],
  partnerRepresentants: [],
  globalNotifications: [],
  guests: [],
  committees: [],
  councils: [],
  realties: [],
  sharesTitles: [],
  partners: [],
  operations: [],
  notes: [],
  shares: [],
  tradingOffers: [],
  tradingOfferOperations: [],
};

export default initialState;
